export enum StepId {
    INIT = "INIT",
    SIGN_IN = "SIGN_IN",
    POST_SIGN_IN = "POST_SIGN_IN",
    PRE_STREAMING = "PRE_STREAMING",
    STREAMING = "STREAMING",
    POST_STREAMING = "POST_STREAMING",
}
